export default __webpack_public_path__ + "static/twitter-b3e6affd049e1e4cc04519f8eaae07c4.png";